var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransportlosninger = function SvgTransportlosninger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Transportlosninger_svg__FlowIcon",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 4.2h4.918a2.1 2.1 0 0 1 1.907 1.22l1.278 2.772h1.317c1.16 0 2.1.94 2.1 2.1V15.4a2.1 2.1 0 0 1-2.1 2.1H14.7zM2.1 0h10.5c1.16 0 2.1.94 2.1 2.1v15.4H2.1A2.1 2.1 0 0 1 0 15.4V2.1C0 .94.94 0 2.1 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 18.55,
    r: 3.15
  })), /*#__PURE__*/React.createElement("g", {
    className: "Transportlosninger_svg__FlowIcon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7 25.2h4.918a2.1 2.1 0 0 1 1.907 1.22l1.278 2.772h1.317c1.16 0 2.1.94 2.1 2.1V36.4a2.1 2.1 0 0 1-2.1 2.1H35.7zM23.1 21h10.5c1.16 0 2.1.94 2.1 2.1v15.4H23.1a2.1 2.1 0 0 1-2.1-2.1V23.1c0-1.16.94-2.1 2.1-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 36.4a3.15 3.15 0 1 1 0 6.3 3.15 3.15 0 0 1 0-6.3m14.7 0a3.15 3.15 0 1 1 0 6.3 3.15 3.15 0 0 1 0-6.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "Transportlosninger_svg__flowIconPrimary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 35a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1zm0-4a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1zM6.5 17a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
  })))));
};
export default SvgTransportlosninger;